<template>
  <com-page>
    <com-search :columns="searchColumns" @search="handleSearch">
      <template>
        <el-button type="primary" @click="handleCreated">新增</el-button>
      </template>
    </com-search>
    <com-card>
      <com-table ref="table" :columns="columns" :api="api">
        <template #operation="row">
          <el-button type="primary" size="mini" @click="handleEdit(row.data)">编辑</el-button>
          <el-button type="danger" size="mini" @click="handleDelete(row.data)">删除</el-button>
        </template>
        <template #createdTime="row">
          {{ row.data.createTime | formatDate }}
        </template>
      </com-table>
    </com-card>
    <the-created-question ref="question" @success="update"></the-created-question>
  </com-page>
</template>

<script>
import { listApi, deleteQuestion } from '@/api/help-center'

import TheCreatedQuestion from './components/the-created-question'

export default {
  components: { TheCreatedQuestion },
  data() {
    return {
      api: listApi,
      searchColumns: [
        {
          label: '问题',
          prop: 'title',
          type: 'input'
        }
      ],
      columns: [
        {
          label: '问题',
          prop: 'title',
          auto: true
        },
        {
          label: '分类',
          prop: 'categoryName'
        },
        {
          label: '创建时间',
          prop: 'createdTime',
          slotName: 'createdTime',
          type: 'slot',
          width: '180'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation'
        }
      ]
    }
  },
  methods: {
    update() {
      this.$refs.table.getList()
    },
    handleEdit(row) {
      const params = {
        type: 'edit',
        row
      }
      this.$refs.question.open(params)
    },
    handleDelete(row) {
      this.$confirm('是否确认删除该问题, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            code: row.code
          }
          deleteQuestion(params).then((res) => {
            const { desc } = res
            this.$message.success(desc)
            this.update()
          })
        })
        .catch(() => {})
    },
    handleCreated() {
      const params = {
        type: 'created'
      }
      this.$refs.question.open(params)
    },
    handleSearch(val) {
      this.$refs.table.search(val)
    }
  }
}
</script>
